import { PublicMedia } from '@weave/schema-gen-ts/dist/schemas/messaging/media/public/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPublicMedia = bindHTTP(PublicMedia);
